import { gql } from "@apollo/client";

// Mutation for creating a NAM contract (NAM, NAM_VIPM, NAM_VIPP are deduced from the price)
export const NamCreateContract = gql`
  mutation Web_NamCreateContract($input: nam_create_contract_input!) {
    contract: nam_create_contract(input: $input) {
      contract_id
    }
  }
`;

// Mutation for updating drop-off data on NAM contract
export const NamSetDropoff = gql`
  mutation Web_namAgentSetDropoff($input: nam_dropoff_input!) {
    contract: nam_set_dropoff(input: $input) {
      contract_id
    }
  }
`;

// Mutation for notifying the mill that the pickup is completed on an existing NAM contract
export const NamCompletePickup = gql`
  mutation Web_NamCompletePickup($input: nam_complete_pickup_input!) {
    contract: nam_complete_pickup(input: $input) {
      contract_id
    }
  }
`;

export const NamUpdatePhotos = gql`
mutation Web_namAgentUpdateDropoffPhotos($input: nam_photo_update_input!) {
  contract: nam_update_photos(input: $input) {
        contract_id
  }
}
`;

export const getContractAgent = gql`
query Web_GetAgentContract($statementId: Int!) {
  contract: nam_contract_detail(filter: { statement_id: $statementId }) {
    contract_id
    status
    market_day
    party
    financials {
      net_quantity
    }
    children_contracts_details {
      statement {
        id
        total_amount
        photos {
          type
          uri
        }
        line_items {
          sku
          total
          quantity
          price_per_unit
          title
        }
      }
    }
    harvests {
      loaded_quantity
      photos {
        uri
        type
        position {
          coordinates
        }
      }
      land_plot {
        id
        name
        polygon {
          coordinates
        }
        pickup_position {
          coordinates
        }
      }
    }
    statement {
      id
      total_amount
      photos {
        type
        uri
      }
      line_items {
        sku
        total
        quantity
        price_per_unit
        title
      }
    }
    agent_person {
     first_name
     last_name
     location {
       village
       district
     }
     avatar_uri
    }
    buyer {
      id
      name
      accepts_ne_mobile_dropoff
    }
    agent {
      id
      name
    }
  }
}
`
